<template lang="pug">
    section
        .flex-row
            el-form-item.grow(:label="$t('Name')" prop="name")
                el-input(type="text" v-model="name")
            el-form-item.colorpicker(:label="$t('Color')" prop="color")
                el-color-picker(v-model="color")
        el-form-item.no-margin(:label="$t('Description')" prop="description")
            quill-editor(v-model="description" :options="quillConfig")
</template>

<i18n>
{
    "de": {
        "Name": "Name",
        "Color": "Farbe",
        "Description": "Beschreibung"
    }
}
</i18n>

<script>

import _ from 'lodash'
// import Vue from 'vue'
import { mapGetters } from 'vuex'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import quillConfig from '@/quill/config'
import store from '@/store'

export default {
    name: 'Main',
    data() {
        quillConfig.modules.link.pages = this.pageOptions
        return {
            quillConfig,
        }
    },
    computed: {
        name: {
            get() {
                return _.get(this.form, 'name', '')
            },
            set: value => store.commit('ext_eventManager_category/form/name', value)
        },
        description: {
            get() {
                return _.get(this.form, 'description', '')
            },
            set: value => store.commit('ext_eventManager_category/form/description', value)
        },
        color: {
            get() {
                return _.get(this.form, 'color', '')
            },
            set: value => store.commit('ext_eventManager_category/form/color', value)
        },
        // isUpdate() {
        //     return !! _.get(this.form, 'id')
        // },
        ...mapGetters({
            form: 'ext_eventManager_category/form',
        }),
    },
}
</script>

<style lang="sass" scoped>
    .flex-row
        display: flex
        justify-content: space-between
        .grow
            flex-grow: 1
            margin-right: 1rem
</style>
